export default (actionName, actionValue = 'true', breadcrumbOptions = {}) => {
  const sentry = useNuxtApp()?.$sentry;

  if (!sentry) {
    return;
  }

  // Add breadcrumb for timeline context
  sentry.addBreadcrumb({
    category: 'user_action',
    message: `User action: ${actionName}`,
    level: 'info',
    ...breadcrumbOptions,
  });

  // Set unique tag with prefix for this action
  sentry.setTag(`user.action.${actionName}`, String(actionValue));
};
